import React from 'react';
import { Link } from 'react-router-dom';
import SocialIcons from './SocialIcons';

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-top">
          <div>
            <div className="footer-brand-name">Zah<span className="brand-accent">e</span>la</div>
            <p className="footer-brand-desc">
              B2B Outbound & AI Automation Firm. We build custom outbound sales engines and AI-driven automation workflows that scale revenue with precision.
            </p>
          </div>
          <div className="footer-col">
            <div className="footer-col-title">Pages</div>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/sales-system">Sales System</Link></li>
              <li><Link to="/case-studies">Case Studies</Link></li>
              <li><Link to="/criteria">Criteria</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <div className="footer-col-title">Services</div>
            <ul>
              <li><Link to="/services">Outbound Systems</Link></li>
              <li><Link to="/services">AI Automation</Link></li>
              <li><Link to="/services">Lead Generation</Link></li>
              <li><Link to="/services">Sales Infrastructure</Link></li>
              <li><Link to="/services">CRM Integration</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <div className="footer-col-title">Contact</div>
            <ul>
              <li><a href="mailto:Hello@Zahela.ca">Hello@Zahela.ca</a></li>
              <li><Link to="/contact">Book a Call</Link></li>
            </ul>
            <SocialIcons />
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Zahela. All rights reserved.</p>
          <p>zahela.ca</p>
        </div>
        <p className="footer-credit">
          Designed by <a href="https://websites.zahela.ca">Websites.zahela.ca</a>
        </p>
      </div>
    </footer>
  );
}
